import React, { useState } from 'react';
import { documents as documentsApi } from '../../utils/api';
import { FolderIcon, DocumentIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import DocumentUploadForm from '../Documents/DocumentUploadForm';
import { useAuth } from '../../context/AuthContext';
import { formatDate } from '../../utils/dateUtils';

const DocumentsSection = ({ documents = [], coinId, onUploadSuccess }) => {
  const { user } = useAuth();
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  return (
    <>
      <div className="bg-white shadow sm:rounded-lg">
        <div className="bg-gray-50 px-4 py-5 border-b border-gray-200 sm:px-6">
          <h3 className="text-base font-semibold leading-6 text-gray-900">
            Documents
          </h3>
        </div>
        <div className="px-4 py-5 sm:p-6">
          {!documents?.length ? (
            <div className="flex flex-col items-center justify-center text-gray-500 py-8">
              <FolderIcon className="h-12 w-12 mb-3" />
              <span>No documents attached</span>
            </div>
          ) : (
            <div className="space-y-2 mb-4">
              {documents.map((doc) => (
                <Link
                  key={doc.id}
                  to={`/documents/${doc.id}`}
                  className="block p-3 bg-gray-50 rounded-md hover:bg-gray-100 transition-colors duration-150"
                >
                  <div className="flex items-center">
                    <DocumentIcon className="h-5 w-5 text-gray-400 mr-2 flex-shrink-0" />
                    <div className="min-w-0 flex-1">
                      <div className="text-sm font-medium text-gray-900 truncate">{doc.title}</div>
                      <div className="text-xs text-gray-500">
                        {doc.type_name} • {formatDate(doc.created_at, { user, includeTime: true })}
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
          
          <button
            onClick={() => setIsUploadModalOpen(true)}
            className="w-full mt-4 inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Upload Document
          </button>
        </div>
      </div>

      <DocumentUploadForm
        open={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
        preSelectedCoins={new Set([coinId])}
        onSuccess={(newDocument) => {
          setIsUploadModalOpen(false);
          if (onUploadSuccess) {
            onUploadSuccess(newDocument);
          }
        }}
      />
    </>
  );
};

export default DocumentsSection;
